angular.module('zc.core')

  .component('zcSessionUpliftModelingClassification', {
    templateUrl: '/templates/core/components/session_uplift_modeling_classification/session_uplift_modeling_classification.html',
    bindings: {
      campaign: '<',
      sessions: '<',
      field: '@'
    },
    controller: sessionUpliftModelingClassificationController,
  });

sessionUpliftModelingClassificationController.$inject = ['$scope'];
function sessionUpliftModelingClassificationController($scope) {
  const vm = this;

  const DELAY_MS = 500;

  vm.$onInit = () => {
    vm.totalSessionCount = 0;
    vm.noConversionAnywaySessionCount = 0;
    vm.conversionAnywaySessionCount = 0;
    vm.negativeImpactSessionCount = 0;
    vm.positiveImpactSessionCount = 0;
    vm.totalConversionCount = 0;
    vm.noConversionAnywayConversionCount = 0;
    vm.conversionAnywayConversionCount = 0;
    vm.negativeImpactConversionCount = 0;
    vm.positiveImpactConversionCount = 0;
    $scope.$watchGroup([
      '$ctrl.campaign.predictions_max_threshold',
      '$ctrl.campaign.predictions_min_threshold',
      '$ctrl.campaign.price_max_threshold',
      '$ctrl.campaign.price_min_threshold',
      '$ctrl.campaign.exclude_no_price',
      '$ctrl.sessions'
    ], _.debounce(calculateSimulation, DELAY_MS), true);
  };

  function calculateSimulation() {
    if(!vm.sessions.length) return;
    const noConversionAnyway = [];
    const conversionAnyway = [];
    const negativeImpact = [];
    const positiveImpact = [];
    vm.sessions.forEach(session => {
      if(isNoConversionAnyway(session)) {
        noConversionAnyway.push(session);
      } else if(isConversionAnyway(session)) {
        conversionAnyway.push(session);
      } else if(isNegativeImpact(session)) {
        negativeImpact.push(session);
      } else {
        positiveImpact.push(session);
      }
    });
    vm.totalSessionCount = vm.sessions.length;
    vm.noConversionAnywaySessionCount = noConversionAnyway.length;
    vm.conversionAnywaySessionCount = conversionAnyway.length;
    vm.negativeImpactSessionCount = negativeImpact.length;
    vm.positiveImpactSessionCount = positiveImpact.length;
    vm.totalConversionCount = _.filter(vm.sessions, 'conversion_count').length;
    vm.noConversionAnywayConversionCount = _.filter(noConversionAnyway, 'conversion_count').length;
    vm.conversionAnywayConversionCount = _.filter(conversionAnyway, 'conversion_count').length;
    vm.negativeImpactConversionCount = _.filter(negativeImpact, 'conversion_count').length;
    vm.positiveImpactConversionCount = _.filter(positiveImpact, 'conversion_count').length;
  }

  function isNoConversionAnyway(session) {
    const prediction = _.get(session, 'predictions_max_before_cart.global_conversion_rate') * 100;
    if(prediction < vm.campaign.predictions_max_threshold) return true;
    return false;
  }

  function isConversionAnyway(session) {
    const prediction = _.get(session, 'predictions_min_before_cart.global_conversion_rate') * 100;
    if(prediction > vm.campaign.predictions_min_threshold) return true;
    return false;
  }

  function isNegativeImpact(session) {
    const price = _.get(session, 'average_recent5_item_price');
    if(!price && vm.campaign.exclude_no_price) return true;
    if(price && vm.campaign.price_max_threshold < price && price < vm.campaign.price_min_threshold) return true;
    return false;
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/components/session_uplift_modeling_classification/session_uplift_modeling_classification.js